export default {
    API_POINT: process.env.VUE_APP_API_POINT,
    PRODUCT_URL: process.env.VUE_APP_PRODUCT_URL,
    POSTS_API: process.env.VUE_APP_POSTS_API,
    CMS_END_POINT: process.env.VUE_APP_CMS_END_POINT
}
